import { render, staticRenderFns } from "./clients.vue?vue&type=template&id=65fd7a8b&scoped=true&"
import script from "./clients.vue?vue&type=script&lang=js&"
export * from "./clients.vue?vue&type=script&lang=js&"
import style0 from "./clients.vue?vue&type=style&index=0&id=65fd7a8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fd7a8b",
  null
  
)

export default component.exports